import { useEffect, useState } from "react";

// "mm:ss.s texte" (or "ss.s texte") per lyric line; lines starting with # are comments
export const parseTimings = (text, count) => {
  const times = [];
  (text || "").split("\n").forEach((raw) => {
    const m = raw.trim().match(/^(?:(\d+):)?(\d+(?:[.,]\d+)?)\b/);
    if (!raw.trim().startsWith("#") && m) times.push((Number(m[1]) || 0) * 60 + Number(m[2].replace(",", ".")));
  });
  return count && times.length >= count ? times.slice(0, count) : null;
};

export const lineAt = (times, t) => {
  let i = 0;
  while (i + 1 < times.length && times[i + 1] <= t) i++;
  return i;
};

const baseSize = (w) => (w >= 1024 ? 60 : w >= 640 ? 48 : 30);

// One shared font size so the longest line fits on a single row
export const useFitSize = (lines, containerRef) => {
  const [size, setSize] = useState(30);
  useEffect(() => {
    let cancelled = false;
    const fit = () => {
      const el = containerRef.current;
      if (!el || cancelled) return;
      const base = baseSize(window.innerWidth);
      const ctx = document.createElement("canvas").getContext("2d");
      ctx.font = `800 ${base}px "Baloo 2", "Fredoka", sans-serif`;
      const widest = Math.max(1, ...lines.map((l) => ctx.measureText(l.text).width));
      const avail = el.clientWidth / 1.06; // active line is scaled up a little
      setSize(Math.max(16, Math.floor(base * Math.min(1, avail / widest))));
    };
    (document.fonts?.ready || Promise.resolve()).then(fit);
    window.addEventListener("resize", fit);
    return () => { cancelled = true; window.removeEventListener("resize", fit); };
  }, [lines, containerRef]);
  return size;
};

// iOS ignores programmatic volume; only show the slider where it works
export const canSetVolume = () => {
  const a = document.createElement("audio");
  a.volume = 0.5;
  return a.volume === 0.5;
};
